import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';

// Import all Scenes here and add to the config var "scene" array (order matters for rendering!)
import { Scene1 } from "./scenes/scene1";
import { Scene2 } from "./scenes/scene2";
import { Scene3 } from "./scenes/scene3";
import { SwitcherScene } from "./scenes/switcherScene";
import { MenuScene } from "./scenes/menuScene";
// import { MainScene } from '../gradeFive_Landscaping/scenes/MainScene';
import { GameScene } from '../phaserDemo/scenes/gameScene';

interface PhaserMultiSceneDemoProps {
}

interface PhaserMultiSceneDemoState {
}

const gameConfig: GameConfig = {
    title: "Multi Scene Demo",
    width: 800,
    height: 600,
    version: "0.0.1-demo",
    backgroundColor: "#000000"
};

class PhaserMultiSceneDemo extends React.Component<PhaserMultiSceneDemoProps, PhaserMultiSceneDemoState> {
    private game: Phaser.Game;
    constructor(props: PhaserMultiSceneDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserMultiSceneDemo.prototype);
    }

    render() {
        var scenes = [MenuScene, SwitcherScene, GameScene, Scene1, Scene2, Scene3];
        return (<div>
            <PhaserGameComponent scenes={scenes} config={gameConfig} />
        </div>);
    }
}

export default PhaserMultiSceneDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserMultiSceneDemo/Main.tsx